import AppReduxProvider from "../AppReduxProvider";
import App from "../App";
import { AppContainerPropsContext } from "../AppContainer";
import SignUpAppRouter from "../Routing/SignUpAppRouter";

const SignUpApp = props => {
  return (
    <AppContainerPropsContext.Provider value={props}>
      <AppReduxProvider>
        <App>
          <SignUpAppRouter />
        </App>
      </AppReduxProvider>
    </AppContainerPropsContext.Provider>
  );
};

export default SignUpApp;
